$(document).ready(function() {
  var country = ""

  window.getCookie = function(name) {
    match = document.cookie.match(new RegExp(name + '=([^;]+)'));
    if (match) return match[1];
  }

  var consent = (getCookie("cookieconsent_status"));

  GeolizrAPI.addEventListener('geolizr.geoData', function(geoData) {
    var country = geoData.countryCode;
    var EUCountry = new RegExp(/AT|BE|BG|HR|CY|CZ|DK|EE|FI|FR|DE|GR|HU|IE|IT|LV|LT|LU|MT|NL|PL|PT|RO|SK|SI|ES|SE/);
    status_opt_out = " ";
  
    if (country.match(EUCountry)) {
      console.log("EU Country");
      window.addEventListener("load", function(){
        window.cookieconsent.initialise({
          "palette": {
            "popup": {
              "background": "#10a7b1f2",
              "text": "#ffffff"
            },
            "button": {
              "background": "#17c7d2",
              "text": "#ffffff"
            }
          },
          "content": {
            "href": "https://www.riversol.com/pages/privacy-policy"
          }
        })
      });
    } else {
      console.log("Not EU country");
      status_opt_out = "false";
      consent == "dismiss";
    }
  });
  
  
});